









import {Component, Prop, Vue} from 'vue-property-decorator';
import {Location} from "vue-router"
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"

/**
 * @status stable
 * @published 3.0.0
 * @changelog 3.0.0 Published.
 * @changelog 3.7.0 Add support for icon.
 */
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsTableBadge extends Vue {
    /**
     * Colors may be used to enhance information about this badge, but **should not** be the only differentiator.
     * Use label text in the default slot, or an icon, to identify badges.
     */
    @Prop({default: 'grey'}) color!: 'grey'|'teal'|'aqua'|'green'|'purple'|'yellow'|'red';

    @Prop({default: null}) to!: Location|null;

    /**
     * **Only** use an icon when explicitly required, and is important to distinguish one badge from another. Don't
     * add an icon for the sake of there being an icon.
     */
    @Prop() icon!: string;
}
